import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import FixtLogo from './logo.svg';

const determineLogosByPriority = (accountLogo, groupLogo) => {
  const logos = [
    { alt: 'Group Logo', image: groupLogo, priority: 1 },
    { alt: 'Account Logo', image: accountLogo, priority: 2 },
    { alt: 'Fixt Logo', image: FixtLogo, priority: 3 },
  ];

  const sortedLogoComponents = logos
    .filter(logo => logo.image)
    .sort((a, b) => a.priority > b.priority)
    .map((logo, i) => (
      <img alt={logo.alt} className="logo" key={logo.alt} src={logo.image} />
    ));

  return [...sortedLogoComponents, null];
};

const getRequestUrl = (groupSlug, msisdn) => {
  let requestUrl = '/requests';

  if (groupSlug) {
    requestUrl += `/${groupSlug}`;
    if (msisdn) {
      requestUrl += `?msdn=${msisdn}`;
    }
  }

  return requestUrl;
};

const Header = ({ groupLogo, accountLogo, groupSlug }) => {
  const [logo] = useMemo(
    () => determineLogosByPriority(accountLogo, groupLogo),
    [accountLogo, groupLogo]
  );
  const [searchParams] = useSearchParams();
  const msisdn = searchParams.get('msisdn') || searchParams.get('msdn') || '';
  const requestUrl = getRequestUrl(groupSlug, msisdn);

  return (
    <Container>
      <a className="logo-container" href={requestUrl} tabIndex={0}>
        {logo}
      </a>
    </Container>
  );
};

const Container = styled.div`
  color: ${props => props.theme.text};
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-container {
    display: flex;
    align-items: center;
  }
  .logo {
    max-height: 50px;
    max-width: 120px;
  }
`;

export default Header;
